import loadable from "@loadable/component";
import { inject } from "mobx-react";
import type { Store } from "@inferno/renderer-shared-core";
import type { WeatherForecast } from "../../services/Weather";
import type { PageBlockInterface } from "../Block.component";

const Weather = loadable(() => import("./Weather.component"));

interface WeatherLoaderProps extends PageBlockInterface {
  store?: Store;
}

export const WeatherLoader = inject("store")(({ store, block }: WeatherLoaderProps) => {
  if (!store) {
    return null;
  }

  // WeatherBug data arrives on the block from WebAPI (IHRWEB-23972); no client-side fetch.
  const forecast = (block as { forecast?: WeatherForecast }).forecast;
  if (!forecast) {
    return null;
  }

  return <Weather block={block} forecast={forecast} />;
});

export default WeatherLoader;
